{
  "common": {
    "loading": "Loading…",
    "cancel": "Cancel",
    "close": "Close"
  },
  "themes": {
    "title": "Website design",
    "intro": "Change how your online shop looks. Edits are saved as a draft first — customers only see them after you publish.",
    "status_live": "On the website now",
    "status_draft": "Draft",
    "updated": "Last changed {{when}}",
    "edit": "Edit",
    "duplicate": "Make a copy",
    "make_live": "Use on the website",
    "make_live_title": "Show “{{name}}” on the website?",
    "make_live_body": "Customers will see this design within a few seconds. The current design is kept and can be brought back.",
    "copy_name": "Copy of {{name}}",
    "copied": "Copy “{{name}}” created as a draft.",
    "published": "The website now uses this design.",
    "action_failed": "That did not work. Please try again.",
    "load_failed": "The designs could not be loaded. Please try again.",
    "empty": "No designs yet."
  },
  "pages": {
    "index": "Home page",
    "product": "Product page",
    "collection": "Category page",
    "list_collections": "All categories",
    "search": "Search results",
    "page": "Information page",
    "policy": "Shop rules page",
    "cart": "Cart",
    "checkout": "Checkout",
    "tracking": "Order tracking",
    "404": "Page not found",
    "password": "Closed shop page",
    "with_suffix": "{{page}} — {{suffix}}"
  },
  "toolbar": {
    "label": "Editor tools",
    "back": "Back",
    "page": "Page to edit",
    "device": "Preview size",
    "device_mobile": "Phone ({{width}} px)",
    "device_tablet": "Tablet ({{width}} px)",
    "device_desktop": "Computer ({{width}} px)",
    "preview_language": "Preview language",
    "undo": "Undo",
    "redo": "Redo",
    "save_draft": "Save draft",
    "publish": "Publish",
    "publishing": "Publishing…",
    "publish_not_allowed": "Only the owner or a manager can publish.",
    "sample_product": "Sample product",
    "sample_collection": "Sample category",
    "sample_none": "choose…",
    "search_product": "Find a product",
    "search_collection": "Find a category",
    "sample_error": "Could not search right now.",
    "sample_empty": "Nothing found.",
    "sample_count_one": "{{count}} item",
    "sample_count_other": "{{count}} items",
    "history": "History",
    "request_publish": "Ask a manager to publish",
    "theme_settings": "Whole website"
  },
  "save": {
    "idle": "No changes",
    "pending": "Changes not saved yet",
    "saving": "Saving…",
    "saved": "Saved",
    "failed": "Could not save",
    "invalid": "Not saved — please fix the marked parts",
    "conflict": "Someone else changed this page",
    "retry": "Try again"
  },
  "tree": {
    "label": "Parts of the page",
    "area": {
      "header": "Top of the website",
      "template": "Page content",
      "footer": "Bottom of the website",
      "overlay": "Pop-ups"
    },
    "group": {
      "announcement": "Announcement bar",
      "header": "Logo and menu",
      "footer": "Bottom of the website",
      "overlay": "Pop-ups"
    },
    "empty": "Nothing here yet.",
    "add_section": "Add a part",
    "add_section_to": "Add a part to {{group}}",
    "actions_for": "Actions for {{name}}",
    "move_up": "Move {{name}} up",
    "move_down": "Move {{name}} down",
    "cannot_move_up": "Already at the top",
    "cannot_move_down": "Already at the bottom",
    "show": "Show {{name}} again",
    "hide": "Hide {{name}}",
    "duplicate": "Copy {{name}}",
    "delete": "Remove {{name}}",
    "drag": "Drag to move {{name}}",
    "expand": "Show the pieces of {{name}}",
    "collapse": "Hide the pieces of {{name}}",
    "hidden": "hidden",
    "issue_count_one": "{{count}} problem",
    "issue_count_other": "{{count}} problems",
    "unknown_section": "Unknown part ({{type}})",
    "unknown_block": "Unknown piece ({{type}})",
    "blocks_of": "Pieces of {{name}}",
    "add_block": "Add a piece",
    "required": "needed on this page",
    "required_raw": "needed for raw cards",
    "required_confirm_title": "Remove “{{name}}”?",
    "required_confirm_raw": "Raw cards must always show their Rank (A–D). Without this piece the product page cannot be published.",
    "required_confirm_body": "This page needs this piece. Without it the page cannot be published.",
    "hide_anyway": "Hide anyway",
    "delete_anyway": "Remove anyway"
  },
  "reasons": {
    "unknown_type": "This part is not available.",
    "lives_in_header": "This part is already in the top of the website.",
    "lives_in_footer": "This part is already in the bottom of the website.",
    "lives_in_overlay": "This part belongs to the pop-ups.",
    "other_pages_only": "This part only works on another page.",
    "not_in_layout_area": "This part cannot go in the top or bottom of the website.",
    "not_on_this_page": "This part cannot be used on this page.",
    "max_reached_one": "This page can have only {{limit}} of these.",
    "max_reached_other": "This page can have at most {{limit}} of these.",
    "fixed": "This part holds the page itself — it cannot be hidden or removed.",
    "limit_reached_one": "Only {{limit}} of this piece is allowed here.",
    "limit_reached_other": "At most {{limit}} of this piece are allowed here.",
    "max_blocks": "This part is full (at most {{limit}} pieces).",
    "no_manifest": "The list of parts is not available yet."
  },
  "named_blocks": {
    "rank_indicator": "Shows the card's condition Rank A–D (A 美品 · B 軽い傷 · C 傷あり · D ダメージ).",
    "grade_badge": "Shows the grading company, grade and certificate number of graded cards.",
    "condition_popup": "A link that opens the explanation of the Rank scale.",
    "card_details": "Card number, set, rarity and language of the card.",
    "trust_notes": "Short reassurance lines: payment, shipping, authenticity."
  },
  "add": {
    "title": "Add a part",
    "intro": "Choose what to add to this page.",
    "intro_group": "Choose what to add to {{group}}.",
    "search": "Search parts",
    "categories": "Kinds of parts",
    "category": {
      "all": "All",
      "banner": "Banners",
      "product": "Products",
      "text": "Text",
      "media": "Pictures & video",
      "other": "Other"
    },
    "results": "Parts you can add",
    "no_results": "No part matches your search."
  },
  "settings": {
    "title": "Settings",
    "pick_something": "Click a part on the left or in the preview to change it.",
    "problems": "Things to fix",
    "hide_block": "Hide this piece",
    "hide_section": "Hide this part",
    "no_settings": "This part has nothing to set."
  },
  "fields": {
    "choose": "— choose —",
    "pick_color": "Pick a colour for {{name}}",
    "language": "Language",
    "missing_translation": "not translated yet",
    "change": "Change",
    "changed_from_default": "changed from the default",
    "contrast_low": "Hard to read on this background ({{ratio}}:1 — aim for 4.5:1 or more)",
    "contrast_ok": "Easy to read on this background ({{ratio}}:1)",
    "css_applied": "What the website applies (only to this part):",
    "css_summary": "Style code (advanced)",
    "default_option": "Default ({{value}})",
    "edit_schemes": "Change the colour sets",
    "exact_value": "Exact value of {{name}}",
    "font_samples": "Font samples",
    "font_unavailable": "{{font}} (not available any more)",
    "help": "Help for {{name}}",
    "html_preview": "What customers will see",
    "html_removed": "not allowed and removed: {{what}}",
    "icon_none": "None",
    "json_broken": "This is not valid yet — the last valid value is kept.",
    "json_summary": "Advanced value (JSON)",
    "list_empty": "Nothing chosen yet.",
    "list_full": "You can choose at most {{max}}.",
    "media_chosen": "File chosen",
    "media_placeholder": "Sample picture (replace it with your own)",
    "media_none_image": "No picture yet",
    "media_none_video": "No video yet",
    "media_none_file": "No file yet",
    "media_pick_image": "Choose a picture",
    "media_pick_video": "Choose a video",
    "media_pick_file": "Choose a file",
    "media_change_image": "Change picture",
    "media_change_video": "Change video",
    "media_change_file": "Change file",
    "off": "Off",
    "on": "On",
    "ref_hint": "Type a {{kind}} link",
    "remove": "Remove",
    "remove_item": "Remove {{name}}",
    "required": "required",
    "scheme_missing": "The colour set “{{id}}” does not exist any more — choose another one.",
    "scheme_name": "Colour set {{n}}",
    "unknown_type": "This setting ({{type}}) is new — type the value carefully.",
    "video_url_hint": "Paste a YouTube or Vimeo address.",
    "pick": {
      "collection": "Choose a category",
      "product": "Choose a product",
      "page": "Choose a page",
      "policy": "Choose a shop rules page",
      "menu": "Choose a menu",
      "attribute": "Choose product information"
    },
    "add": {
      "collection": "Add a category",
      "product": "Add a product"
    },
    "align": {
      "left": "Left",
      "center": "Centre",
      "right": "Right"
    },
    "media_alt_missing": "This picture has no description yet (it will not stop saving).",
    "media_alt_add": "Add a description",
    "media_alt_missing_other_one": "The description is missing in {{count}} language.",
    "media_alt_missing_other_other": "The description is missing in {{count}} languages."
  },
  "preview": {
    "label": "Preview",
    "frame_title": "Preview of the website (draft)",
    "loading": "Loading the preview…",
    "token_failed": "The preview could not be opened",
    "timeout": "The preview did not load",
    "timeout_hint": "Your changes are safe — they are saved as a draft. Try again, or open the preview in a new tab.",
    "retry": "Try again",
    "open_tab": "Open in a new tab"
  },
  "editor": {
    "load_failed": "The editor could not be opened. Please try again.",
    "no_manifest_title": "The website parts are not ready yet",
    "no_manifest_body": "The shop's website has not sent its list of parts yet. This happens automatically when the website is set up — please try again later.",
    "part_load_failed": "“{{what}}” could not be loaded."
  },
  "publish": {
    "confirm_title": "Publish your changes?",
    "confirm_body": "Customers will see the new design within a few seconds. You can go back to the previous version at any time.",
    "done": "Published (version {{version}}). The website updates within a few seconds.",
    "failed": "Could not publish. Check the marked problems and try again.",
    "unsaved": "Some changes are not saved yet — fix them first, then publish."
  },
  "leave": {
    "title": "Leave the editor?",
    "body": "Some changes are not saved yet.",
    "save_and_leave": "Save and leave",
    "stay": "Stay here",
    "switch_title": "Open another page?",
    "switch_body": "Some changes are not saved yet. Save them and open “{{page}}”?",
    "save_and_switch": "Save and open"
  },
  "conflict": {
    "title": "Someone else is editing",
    "body": "“{{what}}” was changed by someone else after you opened it. Load their version (your last changes are dropped) or keep yours (their changes are replaced)?",
    "reload": "Load their version",
    "overwrite": "Keep mine"
  },
  "toast": {
    "section_removed": "“{{name}}” removed.",
    "block_removed": "“{{name}}” removed.",
    "undo": "Undo"
  },
  "narrow": {
    "title": "Please use a computer or a tablet sideways",
    "body": "The website design editor needs a wider screen. Pages, menus and notices can still be changed on this phone.",
    "content": "Edit pages and menus",
    "back": "Back to website design"
  },
  "issues": {
    "generic": "Something here needs checking.",
    "required_missing": "Required: {{setting}} is still empty.",
    "media_missing": "The picture is missing — choose a picture.",
    "media_unverified": "The picture could not be checked yet.",
    "unknown_section_type": "The website no longer has this part.",
    "unknown_block_type": "The website no longer has this piece.",
    "section_not_allowed_here": "This part cannot be used here.",
    "too_many_sections_of_type": "There are too many of this part on the page.",
    "too_many_sections": "The page has too many parts.",
    "too_many_blocks": "This part has too many pieces.",
    "block_limit_exceeded": "There are too many of this piece.",
    "required_block_missing": "A needed piece is missing (for example the Rank on product pages).",
    "invalid_value": "{{setting}} has a value that is not allowed.",
    "invalid_ref": "{{setting}} points to something that is not valid.",
    "invalid_ref_kind": "{{setting}} points to the wrong kind of thing.",
    "ref_not_found": "{{setting}} points to something that does not exist (any more).",
    "ref_not_published": "{{setting}} points to something that is not published yet.",
    "unsafe_html": "The text contains code that is not allowed.",
    "html_cleaned": "Some formatting was removed because the website does not support it.",
    "unsafe_css": "The style code contains something that is not allowed.",
    "unknown_setting": "An old setting ({{setting}}) is no longer used.",
    "unknown_locale": "A text is in a language the shop does not use.",
    "low_contrast": "Text and background colours are hard to read together.",
    "font_not_allowed": "This font cannot be used.",
    "unknown_color_scheme": "This colour set does not exist.",
    "section_not_in_order": "A part is stored but not shown on the page.",
    "manifest_missing": "The list of website parts is not available yet.",
    "color_required": "A colour is missing in a colour set.",
    "invalid_color": "A colour is not written correctly (use #RRGGBB).",
    "duplicate_color_scheme_id": "Two colour sets have the same name.",
    "color_schemes_required": "At least one colour set is needed.",
    "liquid_syntax": "The product data code in a text is broken.",
    "liquid_forbidden_tag": "A text uses code that is not allowed.",
    "template_missing": "A page type has no design yet — those pages would show “not found”."
  },
  "picker": {
    "description": "Search and click the one you want.",
    "empty": "Nothing found.",
    "failed": "Could not search right now. Please try again.",
    "results": "Results",
    "search": "Search",
    "products_count_one": "{{count}} product",
    "products_count_other": "{{count}} products",
    "links_count_one": "{{count}} link",
    "links_count_other": "{{count}} links",
    "status": {
      "active": "on sale",
      "draft": "not on sale",
      "archived": "archived",
      "sold_out": "sold out",
      "published": "published",
      "scheduled": "scheduled",
      "trashed": "in the bin",
      "ready": "ready",
      "processing": "still processing"
    }
  },
  "link": {
    "goes_to": "Goes to",
    "filter_advanced": "Filter (advanced)",
    "only_rank": "Only cards of Rank",
    "rank": "Rank {{rank}}",
    "search_placeholder": "What to search for, e.g. pikachu",
    "target": {
      "collection": "A category",
      "product": "A product",
      "page": "An information page",
      "policy": "A shop rules page",
      "search": "Search results",
      "url": "Another address",
      "filtered": "A category with a filter"
    }
  },
  "liquid": {
    "insert_button": "Insert product data",
    "insert": {
      "product_title": "Product name",
      "product_price": "Price",
      "product_rank": "Rank (A–D)",
      "product_grade": "Grade (graded cards)",
      "product_set": "Set name",
      "product_number": "Card number",
      "collection_title": "Category name",
      "shop_name": "Shop name"
    }
  },
  "translate": {
    "auto": "Translate automatically",
    "copy_all_from_en": "Copy English into every empty field",
    "copy_from_en": "Copy from English",
    "copied_mark": "Copied — please check",
    "machine_mark": "Machine translation — please check",
    "editing_language": "Editing: {{language}}",
    "failed": "The translation did not work. Please try again or type it yourself.",
    "not_enabled": "Automatic translation is not switched on yet. Please type the text or copy it from English.",
    "working": "Translating…"
  },
  "richtext": {
    "bold": "Bold",
    "bullets": "Bullet list",
    "italic": "Italic",
    "link": "Add a link",
    "link_address": "Link address",
    "link_apply": "Add link",
    "numbers": "Numbered list",
    "toolbar": "Text style for {{name}}",
    "unlink": "Remove the link"
  },
  "validation": {
    "invalid": "This value is not allowed.",
    "required": "Please fill this in.",
    "maxLength": "Too long — at most {{limit}} characters.",
    "minLength": "Too short — at least {{limit}} characters.",
    "maximum": "At most {{limit}}.",
    "minimum": "At least {{limit}}.",
    "exclusiveMaximum": "Must be less than {{limit}}.",
    "exclusiveMinimum": "Must be more than {{limit}}.",
    "maxItems": "At most {{limit}} items.",
    "minItems": "At least {{limit}} items.",
    "multipleOf": "Must be a multiple of {{limit}}.",
    "enum": "Please choose one of the options.",
    "type": "This kind of value is not allowed here.",
    "pattern": "The format is not right.",
    "uniqueItems": "The same item is chosen twice.",
    "bad_link": "This link is not valid.",
    "wrong_kind": "This points to the wrong kind of thing ({{kind}}).",
    "liquid_syntax": "The product data code is broken ({{detail}}).",
    "liquid_forbidden_tag": "“{{detail}}” cannot be used here.",
    "liquid_unknown_variable": "Unknown product data: {{detail}}",
    "liquid_unknown_filter": "Unknown formatting: {{detail}}",
    "css_backslash": "Backslashes are not allowed in style code.",
    "css_style_tag": "“</style” is not allowed.",
    "css_script_url": "javascript: links are not allowed.",
    "css_expression": "expression() is not allowed.",
    "css_comment_open": "A comment /* … */ is never closed.",
    "css_quote_open": "A quoted text is never closed.",
    "css_outside_url": "Pictures and links may only come from this shop (addresses starting with /).",
    "css_at_rule": "{{detail}} is not allowed in style code.",
    "css_attr_in_url": "attr() cannot be used inside url().",
    "css_url_open": "url( is never closed.",
    "css_url_malformed": "url() is written wrongly.",
    "css_forbidden": "{{detail}} is not allowed."
  },
  "schemes": {
    "add": "Add a colour set",
    "contrast_button": "Button text",
    "contrast_text": "Text on background",
    "duplicate": "Copy {{name}}",
    "in_use_one": "Used in {{count}} part",
    "in_use_other": "Used in {{count}} parts",
    "last_one": "The website needs at least one colour set.",
    "list": "Colour sets",
    "ratio_low": "{{ratio}}:1 — hard to read",
    "ratio_ok": "{{ratio}}:1 — easy to read",
    "remove": "Remove {{name}}",
    "sample_button": "Add to cart",
    "sample_heading": "Pikachu ex — Rank A",
    "sample_secondary": "Second background",
    "sample_text": "Ships from Japan in 2–3 days.",
    "show_uses": "(show)",
    "role": {
      "background": "Background",
      "text": "Text",
      "accent": "Buttons",
      "accent_contrast": "Text on buttons",
      "secondary": "Second background"
    }
  },
  "theme_settings": {
    "title": "Whole website",
    "group": {
      "localization": "Languages"
    },
    "localization_body": "Which languages the website shows and how visitors are sent to their language is set on the Languages screen. Currencies and countries are on the Markets screen.",
    "migrate": "Update settings",
    "migrate_failed": "The update did not work. Please try again.",
    "migrating": "Updating…",
    "migration_body": "The website got new settings. Update to see them — your current choices are kept.",
    "migration_title": "There are new settings to choose",
    "open_localization": "Open Languages",
    "open_markets": "Open Markets",
    "markets_not_ready": "The Markets screen (currencies and countries) is not ready yet — it comes with the markets update.",
    "recommended_size": "Recommended size: {{size}} px",
    "reset": "Reset to default",
    "reset_body": "All settings of this group go back to the default. You can undo this.",
    "reset_title": "Reset “{{group}}”?"
  },
  "typography": {
    "preview": "How text looks"
  },
  "diff": {
    "added": "added: {{names}}",
    "headline_one": "{{count}} change:",
    "headline_other": "{{count}} changes:",
    "nothing": "Nothing changed compared to the website.",
    "page_added": "new page",
    "page_removed": "page removed",
    "removed": "removed: {{names}}",
    "reordered": "new order",
    "whole_website": "Whole website",
    "marker": {
      "type": "kind of part",
      "disabled": "shown / hidden",
      "blocks": "pieces",
      "block_order": "order of pieces"
    }
  },
  "publish_dialog": {
    "blocked_now": "Something must be fixed first — see the list.",
    "check_failed": "The check did not work. Please try again.",
    "checking": "Saving and checking your changes…",
    "errors_one": "{{count}} thing must be fixed before publishing",
    "errors_other": "{{count}} things must be fixed before publishing",
    "fix": "Fix it",
    "later": "At a time I choose",
    "note": "Note for yourself (optional)",
    "note_placeholder": "e.g. autumn banner",
    "now": "Now",
    "policy_missing": "The shop rules page (特定商取引法に基づく表記) is not complete yet.",
    "publish_now": "Publish now",
    "request_body": "Only the owner or a manager can put changes on the website. Check what changed and send it to them.",
    "request_button": "Send to a manager",
    "request_failed": "Could not send. Please try again.",
    "request_heading": "Ask a manager to publish",
    "request_manual": "Please tell a manager: open “Website design”, then press Publish.",
    "request_sent": "Sent — a manager will see it in their to-do list.",
    "request_title": "Please publish the website design “{{theme}}”",
    "schedule_button": "Schedule",
    "time_label": "Date and time (Japan time)",
    "time_past": "Please choose a time in the future.",
    "title": "Publish your changes",
    "warnings_one": "{{count}} thing to check (you can still publish)",
    "warnings_other": "{{count}} things to check (you can still publish)",
    "when": "When"
  },
  "publish_result": {
    "cancel_schedule": "Cancel",
    "done": "Published (version {{version}}) — the website updates within a few seconds.",
    "not_updated": "The website may not be updated yet.",
    "schedule_cancel_failed": "Could not cancel. Please try again.",
    "schedule_cancelled": "The scheduled publishing was cancelled.",
    "schedule_failed": "The scheduled publishing did not work. Please publish again.",
    "scheduled": "Scheduled — it will be published {{when}} (Japan time).",
    "scheduled_bar": "Will be published {{when}} (Japan time)",
    "unknown": "Published. Open the website to check.",
    "updated": "The website is updated.",
    "updating": "Updating the website…",
    "view_site": "View the website"
  },
  "versions": {
    "back_to_editor": "Back to the editor",
    "compare": "What is different from the draft",
    "compare_intro": "Changes of the current draft compared to this version:",
    "empty": "Nothing has been published yet.",
    "intro": "every time the design was put on the website",
    "load_failed": "The history could not be loaded. Please try again.",
    "restore_draft": "Also make it the draft",
    "restore_draft_hint": "Your current draft is replaced by this version. Leave it off to keep editing your draft.",
    "rollback": "Go back to this version",
    "rollback_body": "Customers will see this version again within a few seconds.",
    "rollback_confirm": "Go back",
    "rollback_failed": "Could not go back. Please try again.",
    "rollback_title": "Go back to version {{version}}?",
    "rolled_back": "The website shows version {{version}} again.",
    "title": "Publishing history",
    "version": "Version {{version}}",
    "reason": {
      "publish": "published",
      "rollback": "went back",
      "scheduled": "scheduled",
      "seed": "first setup",
      "import": "imported"
    }
  },
  "icons": {
    "truck": "Delivery",
    "package": "Parcel",
    "box": "Box",
    "shield": "Protection",
    "badge-check": "Checked",
    "star": "Star",
    "sparkles": "New",
    "heart": "Favourite",
    "gift": "Gift",
    "credit-card": "Payment",
    "rotate-ccw": "Returns",
    "map-pin": "Place",
    "store": "Shop",
    "shopping-bag": "Bag",
    "message-circle": "Message"
  },
  "tour": {
    "open": "How to use the editor (short tour)",
    "progress": "Step {{step}} of {{total}}",
    "close": "Close the tour",
    "skip": "Skip for now",
    "back": "Back",
    "next": "Next",
    "done": "Got it",
    "select": {
      "title": "1. Choose what to change",
      "body": "Click a part in the list on the left — or click it right on the page in the middle, for example the big banner at the top."
    },
    "edit": {
      "title": "2. Change the picture or the words",
      "body": "The boxes on the right change the chosen part: press \"Change picture\" or type new words. Everything is saved as a draft by itself."
    },
    "mobile": {
      "title": "3. Look at it on a phone",
      "body": "Press the phone button to see how the page looks on a phone. Most customers shop on their phone."
    },
    "publish": {
      "title": "4. Put it on the website",
      "body": "Happy with it? Press \"Publish\". Customers see the change within a few seconds.",
      "body_request": "Happy with it? Press \"Send to a manager to publish\" — a manager puts it on the website."
    },
    "undo": {
      "title": "5. You can always go back",
      "body": "Made a mistake? Press Undo (⌘Z / Ctrl+Z). \"History\" puts an earlier version of the website back with two clicks."
    }
  },
  "live": {
    "bar": "“{{what}}” was changed by {{name}} while you were editing.",
    "someone": "someone else",
    "bar_hint": "Loading their version drops what you changed in this part and did not save yet.",
    "load": "Load their version",
    "compare": "Compare",
    "followed": "“{{what}}” now shows the change {{name}} saved.",
    "diff_title": "What is different in “{{what}}”",
    "diff_intro": "Your version in this window compared with the version {{name}} saved.",
    "diff_only_theirs": "Only in their version: {{name}}",
    "diff_only_mine": "Only in your version: {{name}}",
    "diff_changed": "{{name}} is different: {{fields}}",
    "diff_blocks": "items inside",
    "diff_visibility": "shown / hidden",
    "diff_order": "The parts are in a different order.",
    "diff_settings": "Different settings: {{fields}}",
    "diff_same": "No difference: both versions are the same.",
    "diff_loading": "Getting their version…",
    "diff_failed": "Their version could not be loaded. Please try again.",
    "use_theirs": "Use their version",
    "keep_mine": "Keep mine and save",
    "close": "Close"
  }
}
